var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetacellLogo = function SvgMetacellLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#metacell-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24a12 12 0 1 1 0-24 12 12 0 0 1 0 24Zm-2.576-4.059a7.94 7.94 0 1 1 0-15.88 7.94 7.94 0 0 1 0 15.88Z",
    fill: "#1652F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.088 12a4.411 4.411 0 1 0 8.823 0 4.411 4.411 0 0 0-8.823 0Z",
    fill: "url(#metacell-logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 17.753h2.533v-7.545h.033l4.005 7.545h1.027l4.006-7.545h.033v7.545h2.516V6.246h-2.914l-4.154 8.022h-.034L39.43 6.246H36.5v11.507ZM53.783 17.753h8.74V15.55h-6.207v-2.597h5.628v-2.088h-5.628V8.45h6.224V6.246h-8.757v11.507ZM68.527 17.753h2.533V8.465h4.122V6.246H64.406v2.22h4.121v9.287ZM84.436 17.753h2.747l-5.23-11.507h-2.368l-5.214 11.507h2.732l.761-1.775h5.81l.761 1.775Zm-5.629-3.978 1.953-4.586h.034l1.953 4.586h-3.94ZM93.815 18c2.88 0 5.168-1.788 5.48-4.701h-2.431c-.198 1.06-1.427 2.498-3.049 2.498-2.119 0-3.559-1.545-3.559-3.797 0-2.252 1.44-3.797 3.559-3.797 1.947 0 2.85 1.22 3.099 2.359l2.38-.054C98.983 7.48 96.614 6 93.816 6c-3.542 0-6.091 2.499-6.091 6s2.549 6 6.091 6ZM101.628 17.753h8.74V15.55h-6.208v-2.597h5.628v-2.088h-5.628V8.45h6.225V6.246h-8.757v11.507ZM112.995 17.753h8.558v-2.22h-6.025V6.247h-2.533v11.507ZM123.943 17.753h8.557v-2.22h-6.025V6.247h-2.532v11.507Z",
    fill: "#141415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "metacell-logo_svg__b",
    x1: 16.911,
    y1: 11.999,
    x2: 8.088,
    y2: 11.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1652F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "metacell-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h132v24H0z"
  })))));
};
export default SvgMetacellLogo;